// engine/core/ColliderRegistry.ts
import Phaser from "phaser";

export class ColliderRegistry {
    private scene: Phaser.Scene;
    private items: Phaser.Physics.Arcade.Collider[] = [];
    private debug = false;
    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }
    setDebug(enabled: boolean) { this.debug = enabled; }
    log(...args: any[]) { if (this.debug) console.log("[Collision]", ...args); }

    add(c: Phaser.Physics.Arcade.Collider | false | undefined | null) {
        if (!c) return;
        this.items.push(c);
    }

    overlap(
        obj1: Phaser.Types.Physics.Arcade.ArcadeColliderType,
        obj2: Phaser.Types.Physics.Arcade.ArcadeColliderType,
        collideCallback?: Phaser.Types.Physics.Arcade.ArcadePhysicsCallback,
        processCallback?: Phaser.Types.Physics.Arcade.ArcadePhysicsCallback,
        callbackContext?: any
    ) {
        const col = this.scene.physics.add.overlap(
            obj1, obj2, collideCallback, processCallback, callbackContext
        );
        this.add(col);
        return col;
    }

    collider(
        obj1: Phaser.Types.Physics.Arcade.ArcadeColliderType,
        obj2: Phaser.Types.Physics.Arcade.ArcadeColliderType,
        collideCallback?: Phaser.Types.Physics.Arcade.ArcadePhysicsCallback,
        processCallback?: Phaser.Types.Physics.Arcade.ArcadePhysicsCallback,
        callbackContext?: any
    ) {
        const col = this.scene.physics.add.collider(
            obj1, obj2, collideCallback, processCallback, callbackContext
        );
        this.add(col);
        return col;
    }

    destroyAll() {
        for (const c of this.items) try { c.destroy(); } catch { }
        this.items.length = 0;
    }
}
